import * as TerminalHelper from "helpers/TermialHelper";
import { SYSTEM_VIEW } from "const";

export function saveSystemView(view) {
  try {
    return TerminalHelper.saveTerminalSettings({ systemType: view });
  } catch (error) {
    console.error("Error saving system view to storage:", error);
  }
}

export function getSystemView() {
  const terminalSettings = TerminalHelper.getTerminalSettings();
  return terminalSettings.systemType || SYSTEM_VIEW.POS;
}
